import React from "react";
import { useTranslation } from "react-i18next";
import "./styles.css";

const CustomDrawer = ({
  open,
  onClose,
  title,
  children,
  placement = "right",
  width = "378px",
  height = "100%",
  maxWidth
}) => {
  const { t } = useTranslation('common');

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  const handleKeyDown = React.useCallback((e) => {
    if (e.key === "Escape") {
      onClose?.();
    }
  }, [onClose]);

  React.useEffect(() => {
    if (open) {
      document.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "unset";
    };
  }, [open, handleKeyDown]);

  if (!open) return null;

  const getDrawerStyles = () => {
    const baseStyles = {
      width: placement === "left" || placement === "right" ? width : "100%",
      height: placement === "top" || placement === "bottom" ? height : "100%",
      ...(maxWidth ? { maxWidth } : {}),
    };

    switch (placement) {
      case "left":
        return { ...baseStyles, left: 0, top: 0 };
      case "right":
        return { ...baseStyles, right: 0, top: 0 };
      case "top":
        return { ...baseStyles, top: 0, left: 0, width: "100%" };
      case "bottom":
        return { ...baseStyles, bottom: 0, left: 0, width: "100%" };
      default:
        return { ...baseStyles, right: 0, top: 0 };
    }
  };

  return (
    <div className="custom-drawer-backdrop" onClick={handleBackdropClick}>
      <div 
        className={`custom-drawer-container custom-drawer-${placement}`}
        style={getDrawerStyles()}
        role="dialog" 
        aria-labelledby="custom-drawer-title"
      >
        {title && (
          <div className="custom-drawer-header">
            <h3 id="custom-drawer-title" className="custom-drawer-title">
              {title}
            </h3>
            <button
              className="custom-drawer-close"
              onClick={onClose}
              type="button"
              aria-label={t('buttons.close')}
            >
              ×
            </button>
          </div>
        )}
        
        <div className="custom-drawer-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CustomDrawer;
